export default __webpack_public_path__ + "static/media/Android.af650a46.svg";